import $ from 'jquery';

/**
 * Mobile navigation toggle
 * @param {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle').toggleClass('open');
    $('body').toggleClass('menu-open');
    $('.header__navigation').fadeToggle();
};

$('.js-menu-toggle').on('click', toggleMenu);

const initTestimonialsSlider = () => {
    $('.js-testimonials-slider').each((_, sliderEl) => {
        const $slider = $(sliderEl);
        const $track = $slider.find('.home-testimonials__list');
        const $slides = $track.find('.home-testimonials__item');
        const $prev = $slider.find('.home-testimonials__arrow--prev');
        const $next = $slider.find('.home-testimonials__arrow--next');
        const $dotsWrap = $slider.find('.home-testimonials__dots');

        if ($slides.length <= 1) {
            $prev.hide();
            $next.hide();
            $dotsWrap.hide();
            return;
        }

        let activeIndex = 0;

        const setSlide = (index) => {
            const last = $slides.length - 1;
            activeIndex = Math.max(0, Math.min(index, last));
            $track.css('transform', `translateX(-${activeIndex * 100}%)`);
            $prev.prop('disabled', activeIndex === 0);
            $next.prop('disabled', activeIndex === last);
            $dotsWrap.find('.home-testimonials__dot').removeClass('is-active')
                .eq(activeIndex).addClass('is-active');
        };

        $slides.each((slideIndex) => {
            const $dot = $('<button type="button" class="home-testimonials__dot" aria-label="Go to testimonial"></button>');
            $dot.on('click', () => setSlide(slideIndex));
            $dotsWrap.append($dot);
        });

        $prev.on('click', () => setSlide(activeIndex - 1));
        $next.on('click', () => setSlide(activeIndex + 1));

        setSlide(0);
    });
};

initTestimonialsSlider();

const initHomeGalleryLightbox = () => {
    if (!window.Fancybox) {
        return;
    }

    window.Fancybox.bind('[data-fancybox="home-gallery"]', {
        groupAll: true,
        dragToClose: false,
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: [],
                right: ['zoom', 'close']
            }
        }
    });
};

initHomeGalleryLightbox();

